import './button.scss';

import MuiButton from '@material-ui/core/Button';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Loader } from '../Loader/Loader';

const Button = ({
    copper,
    grey,
    mango,
    red,
    transparent,
    black,
    shadow,
    noTextTransform,
    loading,
    disabled,
    whiteBg,
    classes: {
        root: customRootClass = '',
        outlined: customOutlinedClass = '',
        disabled: customDisabledClass = '',
        label: customLabelClass = '',
        ...otherClasses
    },
    ...rest
}) => {
    const classes = {
        root: classnames({
            'pst-button': true,
            root: true,
            copper,
            grey,
            mango,
            transparent,
            black,
            red,
            shadow,
            noTextTransform,
            whiteBg,
            [customRootClass]: customRootClass,
        }),
        outlined: classnames({
            outlined: true,
            [customOutlinedClass]: customOutlinedClass,
        }),
        disabled: classnames({
            disabled: true,
            [customDisabledClass]: customDisabledClass,
        }),
        label: classnames({
            label: true,
            loading,
            [customLabelClass]: customLabelClass,
        }),
        ...otherClasses,
    };

    if (loading) {
        return (
            <MuiButton classes={classes} disabled={disabled} {...rest}>
                <Loader diabled={disabled} medium />
            </MuiButton>
        );
    }

    return <MuiButton classes={classes} disabled={disabled} {...rest} />;
};

Button.propTypes = {
    variant: PropTypes.string,
    classes: PropTypes.shape({
        root: PropTypes.string,
        label: PropTypes.string,
        outlined: PropTypes.string,
        contained: PropTypes.string,
    }),
    copper: PropTypes.bool,
    grey: PropTypes.bool,
    mango: PropTypes.bool,
    red: PropTypes.bool,
    transparent: PropTypes.bool,
    noTextTransform: PropTypes.bool,
    /** Style the bg as black */
    black: PropTypes.bool,
    /** Show a loader inside the button */
    loading: PropTypes.bool,
};

Button.defaultProps = {
    classes: {
        root: '',
        label: '',
        outlined: '',
        contained: '',
    },
    copper: false,
    grey: false,
    red: false,
    mango: false,
    transparent: false,
    noTextTransform: false,
    black: false,
    loading: false,
};

export { Button };
